import * as React from 'react';
import { useSelector } from 'react-redux';
import { getOffer, selectMainPromo } from 'shared/selectors/newObject';

import { trackPromoClick } from './tracking';
import { PurchaseTermsPromo } from '../../components/PurchaseTermsPromo';
import { NewbuildingPromoDetailsContainer } from '../NewbuildingPromoDetails';

export const PurchaseTermsPromoContainer: React.FC = () => {
  const promo = useSelector(selectMainPromo);
  const offer = useSelector(getOffer);

  const [isOpen, setIsOpen] = React.useState(false);

  const handleClick = React.useCallback(() => {
    /* istanbul ignore next */
    if (!promo) {
      return;
    }

    trackPromoClick({
      promoType: promo.promoType,
      promoId: promo.uniquePromoId,
    });
    setIsOpen(true);
  }, [promo]);

  const handleClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  /* istanbul ignore next */
  if (!promo) {
    return null;
  }

  return (
    <>
      <PurchaseTermsPromo title={promo.name} onClick={handleClick} promo={promo} />
      <NewbuildingPromoDetailsContainer
        open={isOpen}
        onClose={handleClose}
        promo={promo}
        offer={offer}
        placeType="different_price"
      />
    </>
  );
};
